import { render, staticRenderFns } from "./ShareToFacebookMessenger.vue?vue&type=template&id=e7e52b3a&"
import script from "./ShareToFacebookMessenger.vue?vue&type=script&lang=js&"
export * from "./ShareToFacebookMessenger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports